/** @jsxImportSource @emotion/react */
import { Button, Divider, FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, Snackbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useFormik } from 'formik';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { useEffect } from 'react';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import FullScreenLoader from '../../Components/FullScreenLoader';
import NomineeFields from './NomineeFields';
import { useNavigate } from "react-router-dom";
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import { detailChecker, steps, getGlobalSteper } from '../../Helper/AppStepperData';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';

function NomineeDetails(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)    
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const navigate = useNavigate()
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [responseStatus, setResponseStatus] = useState({})
    const [loading, setLoading] = useState(false);
    const [nomineeCount, setNomineeCount] = useState(0)
    const [pincodeOptions, setPincodeOptions] = useState([])
    const [relationOptions, setRelationOptions] = useState([])
    const [prefixOptions, setPrefixOptions] = useState([])
    const [open, setOpen] = useState({ nom: false, guard: false });
    const [objectionState, setObjectionState] = useState({"isObjection" : false, "objections" : []})
    const [identityDetails, setIdentityDetails] = useState([])

    const [openInnerDialog, setOpenInnerDialog] = useState(false);
    const localeText = useContext(Il8nContext)

    useEffect(() => {
        getRelationOptions()
        getIdentificationDetails()
        getNomineePrefix()
        getStageDetails()

        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection=>objection.navigationPath == "/NomineeDetails")
            
        if(objections?.length>0){
            objections = objections.map(objection => { 
                return {
                    "objectionDescription" : objection.objectionDescription, 
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection=> { 
                if(objection.navigationPath == "/NomineeDetails"){
                    objection.isNavigationDone = true; 
                }
                return objection 
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection : true, objections })
        }

    }, [])

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    if (detailChecker(resp.data.success.stageDetilasList, 0)) {
                        getAddressDetails()
                    }
                    if (detailChecker(resp.data.success.stageDetilasList, 3)) {
                        getNomineeDetails();
                    }
                    else {
                        setLoading(false)
                    }
                    
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                console.log(err.message)
                setLoading(false)
            })
    }

    const getAddressDetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getAddressDetails).then(resp => {
            setLoading(false)
            if (resp.data.success) {
                dispatch(addStageData({ ...store, addressFatcaDetails: resp.data.success[0] }))
                dispatch(updateStepper({ step: 2, nestedStep: 2 }));
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            setLoading(false)
            console.log(err.message)
        })
    }

    const isMinorNominee = (dateVal) => {
        let date = dateVal || new Date()
        let isMinor = false;
        if (date) {
            let year, month, day;
            year = date.getFullYear();
            month = (date.getMonth() + 1).toString().padStart(2, '0');
            day = date.getDate().toString().padStart(2, '0');
            isMinor = new Date((Number(year) + 18), (Number(month) - 1).toString(), day) >= new Date();
        }
        return isMinor
    }

    const getNomineeFields = () => {
        return [
            "prefix",
            "nameOfNominee",
            "dateOfBirth",
            "relationship",
            "nomAddressSameAs",
            "address",
            "pincode",
            "city",
            "state",
            "country",
            "mobile",
            "emailID",
            "nomineeIdentificationType",
            "nomineeIdentificationDetail",
            "sharePercentage",
            "isGuardian",
            "guardPrefix",
            "nameOfGuardian",
            "guardRelationship",
            "guardAddressSameAs",
            "guardAddress",
            "guardPincode",
            "guardCity",
            "guardState",
            "guardCountry",
            "guardMobile",
            "guardEmailID",
            "guardIdentificationType",
            "guardIdentificationDetail",
        ]
    }

    const getNomineeFieldsValidations = () => {
        let validations = {}
        for (let i = 1; i <= nomineeCount; i++) {
            validations["prefix" + i] = yup.string('')
                .when('addNominee', {
                    is: 'Yes',
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsPrefixRequired),
                    otherwise: yup.string()
                })
            validations["nameOfNominee" + i] = yup.string('')
                .when('addNominee', {
                    is: 'Yes',
                    then: yup.string('')
                    .matches(/^[a-zA-Z'.]+(?: [a-zA-Z'.]+)*$/, localeText?.nomineeDetailsEnterValidName)
                    .required(localeText?.nomineeDetailsNameofNomineeRequired),
                    otherwise: yup.string()
                })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.string('').notRequired()
            // })
            validations["dateOfBirth" + i] = yup.date('')
                .when('addNominee', {
                    is: 'Yes',
                    then: yup.date('')
                        .required(localeText?.nomineeDetailsDateofBirthRequired),
                    otherwise: yup.date()
                })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.date('').notRequired()
            // })
            validations["relationship" + i] = yup.string('')
                .when('addNominee', {
                    is: 'Yes',
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsRelationshipRequired),
                    otherwise: yup.string()
                })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.string('').notRequired()
            // })
            validations["address" + i] = yup.string('').when('addNominee', {
                is: 'Yes',
                then: yup.string('')
                .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.nomineeDetailsEnterValidAddress)
                .required(localeText?.nomineeDetailsAddressRequired),
                otherwise: yup.string()
            })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.string('').notRequired()
            // })
            validations["pincode" + i] = yup.string('').when('addNominee', {
                is: 'Yes',
                then: yup.string('')
                    .required(localeText?.nomineeDetailsPincodeRequired),
                otherwise: yup.string()
            })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.string('').notRequired()
            // })
            validations["city" + i] = yup.string('').when('addNominee', {
                is: 'Yes',
                then: yup.string('')
                    .required(localeText?.nomineeDetailsCityRequired),
                otherwise: yup.string()
            })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.string('').notRequired()
            // })
            validations["state" + i] = yup.string('').when('addNominee', {
                is: 'Yes',
                then: yup.string('')
                    .required(localeText?.nomineeDetailsStateRequired),
                otherwise: yup.string()
            })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.string('').notRequired()
            // })
            validations["country" + i] = yup.string('').when('addNominee', {
                is: 'Yes',
                then: yup.string('')
                    .required(localeText?.nomineeDetailsCountryRequired),
                otherwise: yup.string()
            })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.string('').notRequired()
            // })
            validations["mobile" + i] = yup.string('').when('addNominee', {
                is: 'Yes',
                then: yup.string('')
                .matches(/^[5-9][0-9]{9}$/, localeText?.nomineeDetailsEnterValidNum)
                .required(localeText?.nomineeDetailsMobNumRequired),
                otherwise: yup.string()
            })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.number('').notRequired()
            // })
            validations["emailID" + i] = yup.string('').when('addNominee', {
                is: 'Yes',
                then: yup.string('')
                    .required(localeText?.nomineeDetailsEmailIDRequired).email(localeText?.nomineeDetailsInvalidEmailID),
                otherwise: yup.string()
            })
            validations["nomineeIdentificationType" + i] = yup.string('').nullable()
            validations["nomineeIdentificationDetail" + i] = yup.string('').nullable().when('addNominee', {
                is: 'Yes',
                then: yup.string('').nullable()
                    .required(localeText?.nomineeDetailsIdentificationDetailRequired),
                otherwise: yup.string().nullable()
            })

            validations["sharePercentage" + i] = yup.number('').when('addNominee', {
                is: 'Yes',
                then: yup.number('')
                    .required(localeText?.nomineeDetailsSharePercentageRequired).max(100, localeText?.nomineeDetailsSharePercentageBetween1to100).min(1, localeText?.nomineeDetailsSharePercentageBetween1to100)
                    .typeError(localeText?.nomineeDetailsInvalidEntry),
                otherwise: yup.number()

            })
            // .when('addNominee', {
            //     is: 'No',
            //     then: yup.number('').notRequired()
            // })

            if (isMinorNominee(new Date())) {
                validations["guardPrefix" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsPrefixRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["nameOfGuardian" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                    .matches(/^[a-zA-Z'.]+(?: [a-zA-Z'.]+)*$/, localeText?.nomineeDetailsEnterValidName)
                    .required(localeText?.nomineeDetailsNameofGuardianRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardRelationship" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsRelationshipRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardAddress" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                    .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.nomineeDetailsEnterValidAddress)
                    .required(localeText?.nomineeDetailsAddressRequired),
                    otherwise: yup.string('')

                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardPincode" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsPincodeRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardCity" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsCityRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardState" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsStateRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardCountry" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsCountryRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardMobile" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .matches(/^[5-9][0-9]{9}$/, localeText?.nomineeDetailsEnterValidNum)
                        .required(localeText?.nomineeDetailsMobNumRequired),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                validations["guardEmailID" + i] = yup.string('').when('isGuardian' + i, {
                    is: true,
                    then: yup.string('')
                        .required(localeText?.nomineeDetailsEmailIDRequired).email(localeText?.nomineeDetailsInvalidEmailID),
                    otherwise: yup.string('')
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('')
                    })
                    validations["guardIdentificationType" + i] = yup.string('').nullable()
                validations["guardIdentificationDetail" + i] = yup.string('').nullable().when('isGuardian' + i, {
                    is: true,
                    then: yup.string('').nullable()
                        .required(localeText?.nomineeDetailsIdentificationDetailRequired),
                    otherwise: yup.string('').nullable()
                })
                    .when("addNominee", {
                        is: "No",
                        then: yup.string('').nullable()
                    })

            }
        }
        return validations
    }

    const validationSchema = yup.object({
        addNominee: yup
            .string(''),
        ...getNomineeFieldsValidations()
    });

    const formik = useFormik({
        initialValues: {
            addNominee: "No",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if (values.addNominee == "Yes") {
                let shareSum = 0;
                for (let i = 1; i <= nomineeCount; i++) {
                    shareSum += Number(values["sharePercentage" + i])
                }
                if (shareSum != 100) {
                    setResponseStatus({ "message": localeText?.nomineeDetailsPercentage, "type": "error" })
                    setSnackBarOpen(true)
                    return;
                }
            }
            handleNomineeSubmit(values)
        },
    });

    const getDateValue = (dateString) => {
        dateString = dateString.split("/")
        let date = dateString[0]
        let month = dateString[1] - 1
        let year = dateString[2]
        return new Date(year, month, date)
    }

    
    const setInitialNomineeFieldValues = (nomineeData) => {
        setNomineeCount(nomineeData.length)
        let uploadedDocs = [];
        let docDetails = [];
        nomineeData.forEach((nominee, index) => {
            let i = index + 1
            formik.setFieldValue("prefix" + i, nominee.nomineeNamePrefix)
            formik.setFieldValue("nameOfNominee" + i, nominee.nomineeFirstName)
            formik.setFieldValue("dateOfBirth" + i, getDateValue(nominee.nomineeDob))
            formik.setFieldValue("relationship" + i, nominee.relationWithNominee)
            // formik.setFieldValue("nomAddressSameAs" + i, nominee.)
            formik.setFieldValue("address" + i, nominee.nomineeAddress1 + nominee.nomineeAddress2)
            formik.setFieldValue("pincode" + i, nominee.nomineePincode)
            formik.setFieldValue("city" + i, nominee.nomineeCity)
            formik.setFieldValue("state" + i, nominee.nomineestate)
            formik.setFieldValue("country" + i, nominee.nomineeCountry)
            formik.setFieldValue("mobile" + i, nominee.nomineeMobile)
            formik.setFieldValue("emailID" + i, nominee.nomineeEmail)
            formik.setFieldValue("nomineeIdentificationType" + i, nominee.nomineeIdentificationDetail)
            formik.setFieldValue("nomineeIdentificationDetail" + i, nominee.nomineeIdentificationDetailData)
            formik.setFieldValue("sharePercentage" + i, nominee.nominationPercent)
            // formik.setFieldValue("nomineeShareEqual", nominee.isNominationPercentEqual)
            formik.setFieldValue("isGuardian" + i, nominee.guardian)

            if (nominee.guardian && nominee.kycStagingGuardians && nominee.kycStagingGuardians[0]) {
                nominee.kycStagingGuardians[0].kycFormProofUpload.forEach(doc => {
                    uploadedDocs.push({
                        "documentTypeCode": doc.documentTypeCode,
                        "kycstgProofId": doc.kycstgProofId,
                        "documentOf": doc.documentTypeCode + i
                    })
                    docDetails.push({...doc, documentTypeCode: doc.documentTypeCode + i})
                })
                formik.setFieldValue("guardPrefix" + i, nominee.kycStagingGuardians[0].guardianNamePrefix)
                formik.setFieldValue("nameOfGuardian" + i, nominee.kycStagingGuardians[0].guardianFirstName)
                formik.setFieldValue("guardRelationship" + i, nominee.kycStagingGuardians[0].guardianRelation)
                // formik.setFieldValue("guardAddressSameAs" + i, nominee.kycStagingGuardians[0].)
                formik.setFieldValue("guardAddress" + i, nominee.kycStagingGuardians[0].guardianAddress1)
                formik.setFieldValue("guardPincode" + i, nominee.kycStagingGuardians[0].guardianPincode)
                formik.setFieldValue("guardCity" + i, nominee.kycStagingGuardians[0].guardianCity)
                formik.setFieldValue("guardState" + i, nominee.kycStagingGuardians[0].guardianState)
                formik.setFieldValue("guardCountry" + i, nominee.kycStagingGuardians[0].guardianCountry)
                formik.setFieldValue("guardMobile" + i, nominee.kycStagingGuardians[0].guardianMobileNo)
                formik.setFieldValue("guardEmailID" + i, nominee.kycStagingGuardians[0].guardianEmailId)
                formik.setFieldValue("guardIdentificationType" + i, nominee.kycStagingGuardians[0].guardianIdentificationDetail)
                formik.setFieldValue("guardIdentificationDetail" + i, nominee.kycStagingGuardians[0].guardianIdentificationDetailData)

            }
        })
    }

    const getIdentificationDetails = () =>{
        axios.get(process.env.REACT_APP_API_URL + config.documentMaster + 8)
            .then(resp => {
                if (resp.data.success) {
                    setIdentityDetails(resp.data.success.documentsReq)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                console.log(err.message)
            })
    }


    const getNomineePrefix = () => {
        let payload = {
            "searchType": "NOMINEEPREFIX",
            "searchValue": "",
            "controlType": "DROPDOWN",
            "conditionOne": "",
            "conditionTwo": "",
            "conditionThree": ""
        }
        axios.post(process.env.REACT_APP_API_URL + config.autoSearch, payload)
            .then(resp => {
                if (resp.data.success) {
                    setPrefixOptions(resp.data.success)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                console.log(err.message)
            })
    }

    const getNomineeDetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getNomineeDetails).then(resp => {
            if (resp.data.success) {
                setLoading(false)
                setInitialNomineeFieldValues(resp.data.success)
                formik.setFieldValue("addNominee", resp.data.success.length > 0 ? "Yes" : "No")
            } else {
                throw new Error(resp.data.error)
            }
        }).catch((error) => {
            setLoading(false)
            setResponseStatus({ "message": error.message, "type": "error" })
            setSnackBarOpen(true)
        })
    }

    const getRelationOptions = () => {
        axios.get(process.env.REACT_APP_API_URL + config.relationOptions).then(resp => {
            if (resp.data.success) {
                setRelationOptions(resp.data.success)
            } else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            console.log(err.message)
        })
    }

    function toogleInnerDialog() {
        setOpenInnerDialog(!openInnerDialog);
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const nextNavigate = () => {
        if (objectionState.isObjection) {
            objectionNavigation(navigate)
        }
        else {
            dispatch(updateStepper({ step: 2, nestedStep: 3 }));
            navigate("/BankDetails")
        }
    }

    const handleNomineeSubmit = (values) => {
        setLoading(true)
        let obj = {}
        obj.isNominee = values.addNominee == "Yes"
        if (values.addNominee == "Yes") {
            for (let i = 1; i <= nomineeCount; i++) {
                let nomineeKey = "nominee" + i
                let isGuardian = isMinorNominee(values["dateOfBirth" + i])
                obj[nomineeKey] = {}
                obj[nomineeKey]["nomineeNamePrefix"] = values["prefix" + i]
                obj[nomineeKey]["nomineeFirstName"] = values["nameOfNominee" + i]
                obj[nomineeKey]["nomineeDob"] = values["dateOfBirth" + i]?.getTime()
                obj[nomineeKey]["relationWithNominee"] = values["relationship" + i]
                obj[nomineeKey]["nomineeAddress1"] = values["address" + i]
                obj[nomineeKey]["nomineePincode"] = values["pincode" + i]
                obj[nomineeKey]["nomineeCity"] = values["city" + i]
                obj[nomineeKey]["nomineestate"] = values["state" + i]
                obj[nomineeKey]["nomineeCountry"] = values["country" + i]
                obj[nomineeKey]["nomineeMobile"] = values["mobile" + i]
                obj[nomineeKey]["nomineeEmail"] = values["emailID" + i]
                obj[nomineeKey]["nomineeIdentificationDetail"] = values["nomineeIdentificationType" + i]
                obj[nomineeKey]["nomineeIdentificationDetailData"] = values["nomineeIdentificationDetail" + i]
                obj[nomineeKey]["isNominationPercentEqual"] = values["nomineeShareEqual"]
                obj[nomineeKey]["nominationPercentage"] = values["sharePercentage" + i]
                obj[nomineeKey]["guardian"] = isGuardian
                if (isGuardian) {
                    obj[nomineeKey]["guardianNamePrefix"] = values["guardPrefix" + i]
                    obj[nomineeKey]["guardianFirstName"] = values["nameOfGuardian" + i]
                    obj[nomineeKey]["guardianRelation"] = values["guardRelationship" + i]
                    obj[nomineeKey]["guardianAddress1"] = values["guardAddress" + i]
                    obj[nomineeKey]["guardianPincode"] = values["guardPincode" + i]
                    obj[nomineeKey]["guardianCity"] = values["guardCity" + i]
                    obj[nomineeKey]["guardianState"] = values["guardState" + i]
                    obj[nomineeKey]["guardianCountry"] = values["guardCountry" + i]
                    obj[nomineeKey]["guardianMobileNo"] = values["guardMobile" + i]
                    obj[nomineeKey]["guardianEmailId"] = values["guardEmailID" + i]
                    obj[nomineeKey]["guardianIdentificationDetail"] = values["guardIdentificationType" + i]
                    obj[nomineeKey]["guardianIdentificationDetailData"] = values["guardIdentificationDetail" + i]
                }
            }
        }

        axios.post(process.env.REACT_APP_API_URL + config.nomineeDetails, obj).then(resp => {
            setLoading(false)
            if (resp.data.success) {
                nextNavigate()
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((error) => {
            setLoading(false)
            setResponseStatus({ "message": error.message, "type": "error" })
            setSnackBarOpen(true)
        })

    }

    const setPincodeSearchFields = (searchedItem, index, isGuardian) => {
        if (isGuardian) {
            formik.setFieldValue("guardPincode" + index, searchedItem.pinCode)
            formik.setFieldValue("guardCity" + index, searchedItem.city)
            formik.setFieldValue("guardState" + index, searchedItem.state)
            formik.setFieldValue("guardCountry" + index, searchedItem.country)
        }
        else {
            formik.setFieldValue("pincode" + index, searchedItem.pinCode)
            formik.setFieldValue("city" + index, searchedItem.city)
            formik.setFieldValue("state" + index, searchedItem.state)
            formik.setFieldValue("country" + index, searchedItem.country)
        }
        setPincodeOptions([])
        setOpen({ nom: false, guard: false });

    }

    const getOptionComponent = (searchedItem, index, isGuardian) => {
        return <Grid item css={{ width: "100%", padding: "20px", borderTop: "1px solid grey", cursor: "pointer" }} onClick={() => setPincodeSearchFields(searchedItem, index, isGuardian)}>
            <Typography variant='body1' css={{ fontWeight: "bold" }}>
                {"PIN code : " + searchedItem.pinCode}
            </Typography>
            <Typography variant='body2'>
                {"State : " + searchedItem.state}
            </Typography>
            <Typography variant='body2'>
                {"City : " + searchedItem.city}
            </Typography>
        </Grid>
    }

    let timer;
    const handlePincodeSearch = (e) => {
        if (e.target.value.length > 2) {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                setPincodeOptions([])
                let dataObj = {
                    key: e.target.value,
                    type: "pinCode"
                }
                axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
                    .then(resp => {
                        if (resp.data.success) {
                            setPincodeOptions(resp.data.success)
                        }
                        else {
                            throw new Error(resp.data.error)
                        }
                    }).catch((error) => {
                        setResponseStatus({ "message": error.message, "type": "error" })
                        setSnackBarOpen(true)
                    })
            }, 1000)
        }
    }

    const addNominee = () => {
        if (nomineeCount < 3) {
            setNomineeCount(nomineeCount + 1)
        }
    }

    const resetNomineeFields = (nomineeRemovalIndex) => {
        let fields = getNomineeFields()
        if (nomineeCount !== nomineeRemovalIndex) {
            for (let index = nomineeRemovalIndex; index < nomineeCount; index++) {
                let nextIndex = index + 1;
                fields.forEach(field => {
                    // store.dispatch(change("nomineeDetails", field + index, formValueSelector("nomineeDetails")(store.getState(0), field + nextIndex)))
                    formik.setFieldValue(field + index, formik.values[field + nextIndex])
                })
                // store.dispatch(change("nomineeDetails", "nameOfNomineeShare" + index, formValueSelector("nomineeDetails")(store.getState(0), "nameOfNomineeShare" + nextIndex)))
                // store.dispatch(change("nomineeDetails", "relationOfNomineeShare" + index, formValueSelector("nomineeDetails")(store.getState(0), "relationOfNomineeShare" + nextIndex)))
                // store.dispatch(change("nomineeDetails", "shareOfNominee" + index, formValueSelector("nomineeDetails")(store.getState(0), "shareOfNominee" + nextIndex)))
            }
        }

        fields.forEach(fieldName => {
            // store.dispatch(change("nomineeDetails", fieldName + nomineeCount, undefined))
            // store.dispatch(unregisterField("nomineeDetails", fieldName + nomineeCount))
            formik.setFieldValue(fieldName + nomineeCount, undefined)
            formik.unregisterField(fieldName + nomineeCount)
        })

        if (formik.errors && Object.keys(formik.errors).length > 0) {
            let lastNomineeErrorKeys = Object.keys(formik.errors).filter(key => key.endsWith(nomineeCount))
            let errors = { ...formik.errors }

            lastNomineeErrorKeys.forEach(fieldName => {
                // formik.setFieldError(fieldName, undefined)
                delete errors[fieldName]
            })

            formik.setErrors({ ...errors })
        }
    }

    const deleteNominee = (nomineeRemovalIndex) => {
        resetNomineeFields(nomineeRemovalIndex)
        setNomineeCount(nomineeCount - 1)
        // formik.setFieldTouched
    }

    const handleAddNomineeField = (e, value) => {
        if (value == "Yes" && nomineeCount == 0) {
            setNomineeCount(1)
        }
        if (value == "No" && nomineeCount > 0) {
            for (let i = 1; i <= nomineeCount; i++) {
                if (formik.values["isGuardian" + i]) {
                    formik.setFieldValue("isGuardian" + i, false)
                }
            }
            setNomineeCount(0)
        }
        formik.setFieldValue("addNominee", value)
    }

    return (
        <>
            <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
                <PageLayout css={{ overflowY: "scroll" }} showSidebar calculateHeight={isSmallScreen ? true : false} isObjectionScreen={objectionState.isObjection}
                    breadcrumb={{ show: true, steps: steps[1].nestedSteps, step: 2, nestedStep: 3 }}>
                    <ElevatedGrid >
                        <Grid container item alignItems={"start"} spacing={3}>
                            <Grid container item alignItems={"center"}>
                                {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                    {objectionState.objections.map((objection, i) =>
                                        <>
                                            <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                                Objection : {objection.objectionDescription || "--"} | Objection Remark : {objection.remark || "--"} <br />
                                            </Typography>
                                            {i > 0 && <Divider />}
                                        </>
                                    )}
                                </Grid>}
                                <Grid item xs={12}>
                                    <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                        {localeText?.nomineeDetailsTitle}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} alignItems="center" spacing={3}>
                                <Grid item>
                                    <Typography display={"inline"} variant="body1" css={{ fontWeight: "bold" }}>{localeText?.nomineeDetailsAdd}</Typography>
                                </Grid>
                                <Grid item>
                                    <FormControl id="addNominee" name="addNominee" error={formik.touched.addNominee && Boolean(formik.errors.addNominee)}>
                                        <RadioGroup value={formik.values.addNominee} row name="row-radio-buttons-group"
                                            onChange={(e, value) => handleAddNomineeField(e, value)}
                                        >
                                            <FormControlLabel value={"Yes"} control={<Radio size='small' />} label={"Yes"} />
                                            <FormControlLabel value={"No"} control={<Radio size='small' />} label={"No"} />
                                        </RadioGroup>
                                        <FormHelperText>{formik.touched.addNominee && formik.errors.addNominee}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            {formik.values.addNominee == "No" ?
                                <Grid container item xs={12} alignItems="center" spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography display={"inline"} variant="body1" >{localeText?.nomineeDetailsDeclaration}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography display={"inline"} variant="body2" >
                                            {localeText?.nomineeDetailsHereby}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                :
                                <Grid container item xs={12} alignItems={"center"} spacing={3}>
                                    <NomineeFields nomineeCount={nomineeCount} formik={formik} localeText={localeText} pincodeOptions={pincodeOptions}
                                        getOptionComponent={getOptionComponent} handlePincodeSearch={handlePincodeSearch}
                                        store={store} relationOptions={relationOptions} prefixOptions={prefixOptions} deleteNominee={deleteNominee}
                                        isMinorNominee={isMinorNominee} open={open} setOpen={setOpen} uploaded={props.uploaded} identityDetails={identityDetails}
                                    />
                                    <Grid item xs={12} css={{ padding: "20px 0px" ,marginBottom:"30px", justifyContent: isSmallScreen ? "center" : "", display: isSmallScreen ? "flex" : ""}} >
                                        <Button variant="outlined" color="primary" disabled={nomineeCount > 2} onClick={addNominee} >
                                            {localeText?.nomineeDetailsAddNomineeBtn}
                                        </Button>
                                    </Grid>
                                </Grid>
                            }

                        </Grid>
                    </ElevatedGrid>
                    {!isSmallScreen && <Grid item css={{ padding: "20px 0" }}>
                        <Button type="submit" variant='contained' color="primary">
                            {localeText?.nomineeDetailsNext}
                        </Button>
                    </Grid>}
                </PageLayout>
                {isSmallScreen && <Grid item css={{ position: "fixed", textAlign: "center", padding: "15px", width: "100%", bottom: 0, boxShadow: "0px -15px 30px #00000029", backgroundColor: "#FFFFFF", zIndex: "1" }}>
                    <Button type="submit" variant='contained' color="primary">
                        {localeText?.nomineeDetailsNext}
                    </Button>
                </Grid>}
            </form>

            {loading && <FullScreenLoader />}

            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default NomineeDetails;
